import { useEffect } from 'react';
import { postMessage, PostMessageType } from '../../../helpers/whitelable';
import { FORM_NAME } from '../../../constants';

let prevHeight = 0;
let prevUrl = '';
let container: null | HTMLElement = null;

const sendSize = () => {
    if (container === null) {
        container = document.getElementById(FORM_NAME);
    }
    const height = container!.getBoundingClientRect().height;
    const url = window.location.pathname + window.location.search;
    if (height !== prevHeight || url !== prevUrl) {
        prevHeight = height;
        prevUrl = url;

        postMessage({
            type: PostMessageType.appFramePageHeight,
            result: {
                height,
                url,
            },
        });
    }
};

export const useSendSize = (enabled = false) => {
    useEffect(() => {
        if (!enabled) {
            return;
        }
        sendSize();
        const intervalId = setInterval(sendSize, 300);

        return () => clearInterval(intervalId);
    }, []);
};
